// extracted by mini-css-extract-plugin
module.exports = {"Field":"ComponentFormCheckboxField_Field__GUSXE","Type":"ComponentFormCheckboxField_Type__YL_o0","Label":"ComponentFormCheckboxField_Label__jwKYS"};